import { makeStyles } from '@material-ui/core'

export const useReplacementVehicleStepStyles = makeStyles(() => ({
  cards: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--vel-fixed-spacing-05)',
    '& label': {
      width: '100%',
    },
  },
}))
